const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const shiftMonth = (m, n) => {
  const d = new Date(+m.slice(0, 4), +m.slice(5, 7) - 1 + n, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
export const monthLabel = (m) => new Date(+m.slice(0, 4), +m.slice(5, 7) - 1, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });

export function MonthGrid({ month, renderDay, onDayClick }) {
  const y = +month.slice(0, 4), mo = +month.slice(5, 7) - 1;
  const lead = new Date(y, mo, 1).getDay();
  const days = new Date(y, mo + 1, 0).getDate();
  const today = new Date().toISOString().slice(0, 10);
  const cells = [...Array(lead).fill(null), ...Array.from({ length: days }, (_, i) => `${month}-${String(i + 1).padStart(2, "0")}`)];
  return (
    <div className="overflow-x-auto">
      <div className="grid grid-cols-7 min-w-[700px] border-l border-t border-brand-border bg-brand-surface rounded-md overflow-hidden" data-testid="month-grid">
        {DOW.map((d) => <div key={d} className="px-2 py-1.5 text-[10px] uppercase tracking-[0.12em] text-brand-tertiary border-r border-b border-brand-border bg-brand-hover">{d}</div>)}
        {cells.map((day, i) => (
          <div key={day || `x${i}`} onClick={day && onDayClick ? () => onDayClick(day) : undefined}
            className={`min-h-[104px] p-1.5 border-r border-b border-brand-border space-y-1 ${day ? "cursor-pointer hover:bg-brand-hover/60" : "bg-brand-page/50"}`} data-testid={day ? `day-${day}` : undefined}>
            {day && <p className={`text-[11px] ${day === today ? "inline-flex h-5 w-5 items-center justify-center rounded-full bg-brand-ink text-brand-page" : "text-brand-tertiary"}`}>{+day.slice(8)}</p>}
            {day && renderDay(day)}
          </div>
        ))}
      </div>
    </div>
  );
}
